import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
type GoldSealProps = {
  className?: string;
};

/* Round gold "Compra 100% segura" seal with a rotating text ring */
export function GoldSeal({
  className = ''
}: GoldSealProps) {
  return <div className={`relative h-44 w-44 shrink-0 sm:h-48 sm:w-48 ${className}`} role="img" aria-label="Sello: Compra 100% segura" data-id="element-31" data-mp="ih8mmlrzachs">
      {/* Outer gold ring */}
      <div className="seal-ring absolute inset-0 rounded-full" aria-hidden="true" data-id="element-32" data-mp="9gkj4l07nuj5" />

      {/* Circular text */}
      <svg viewBox="0 0 200 200" className="seal-text absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-33" data-mp="egylbmf4sa99">
        <defs data-id="element-34" data-mp="3vpbzozhxjma3">
          <path id="seal-circle" d="M100,100 m-78,0 a78,78 0 1,1 156,0 a78,78 0 1,1 -156,0" data-id="element-35" data-mp="3vpv91rtil2ci" />
        </defs>
        <text className="fill-ink font-display text-[13px] font-extrabold uppercase" letterSpacing="3.2" data-id="element-36" data-mp="4jtu386fholl">
          <textPath href="#seal-circle" data-id="element-37" data-mp="1tuump1zdlyi3">Pago seguro • Acceso inmediato • Entrega digital •</textPath>
        </text>
      </svg>

      {/* Inner medallion */}
      <div className="absolute inset-[26px] flex flex-col items-center justify-center rounded-full bg-brand-950 text-center ring-2 ring-gold-light/70" data-id="element-38" data-mp="18zxryxgwqyuj">
        <ShieldCheckIcon className="h-7 w-7 text-gold sm:h-8 sm:w-8" strokeWidth={2.2} aria-hidden="true" data-id="element-39" data-mp="1iqsnksg1nasn" />
        <span className="mt-1 font-display text-[10px] font-extrabold uppercase tracking-[0.2em] text-white" data-id="element-40" data-mp="1drxv0ys9y7vc">Compra</span>
        <span className="text-gold-shine font-display text-3xl font-extrabold leading-none sm:text-[34px]" data-id="element-41" data-mp="q1bojbxx4vng">100%</span>
        <span className="font-display text-[10px] font-extrabold uppercase tracking-[0.2em] text-white" data-id="element-42" data-mp="l4brtrmyl590">Segura</span>
      </div>
    </div>;
}